import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      {/* iTHNK: role replaces the administrator switch (admin role = administrator) */}
      <SelectInput
        source="role"
        choices={saleRoleChoices}
        defaultValue="sales"
        validate={required()}
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
    </div>
  );
}

const saleRoleChoices = [
  { id: "admin", name: "resources.sales.roles.admin" },
  { id: "sales", name: "resources.sales.roles.sales" },
  { id: "delivery", name: "resources.sales.roles.delivery" },
];
